import { ACTION_TYPES, Details, Error } from '../types';

export const fetchDetailsPending = () => ({
  type: ACTION_TYPES.PENDING,
});

export const fetchDetailsSuccess = (details: Details) => ({
  type: ACTION_TYPES.SUCCESS,
  payload: details,
});

export const fetchDetailsError = (error: Error) => ({
  type: ACTION_TYPES.ERROR,
  payload: error,
});
